import { gql } from '@apollo/client';

export const DELETE_CREDENTIALS_CLIQUE_RETIRE = gql`
  mutation DeleteCliqueRetireCredentials($storeId: ID!) {
    deleteCliqueRetireCredentials(storeId: $storeId) {
      ... on DeleteCliqueRetireCredentialsSuccess {
        code
        message
      }
      ... on Error {
        code
        message
      }
    }
  }
`;
